export const boolCheck = (value?: boolean) => {
  return typeof value === 'boolean' ? value : 'N/A';
};

export default boolCheck;
